export interface ImageProfile {
  width: number
  height: number
  label: string
}

export const IMAGE_PROFILES = {
  food: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
  additional: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
  company: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
  employee: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
  notice: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
  default: { width: 1024, height: 1024, label: "1024 x 1024 px (ou 512 x 512 px para imagens menores)" },
} as const

export type ImageProfileKey = keyof typeof IMAGE_PROFILES
